import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from './App';
import './index.css';
import { attachSessionSupport } from './services/session';

// Pages that call axios directly still send the session cookie and CSRF token.
attachSessionSupport(axios);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Only load PostHog if a key is configured
const posthogKey = process.env.REACT_APP_POSTHOG_KEY;

if (posthogKey) {
  const { PostHogProvider } = require('posthog-js/react');
  const options = {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com',
  } as const;
  root.render(
    <PostHogProvider apiKey={posthogKey} options={options}>
      <App />
    </PostHogProvider>
  );
} else {
  root.render(<App />);
}
